import * as React from 'react';
import * as moment from 'moment';

import { IWACEvent } from '../classes/event';
import Image from '../components/image';
import ListEvent from './list-event';
import { IDay } from '@adage/calendar/services/calendar';

interface ListViewEventProps {
    day: IDay<IWACEvent>;
}

const listRow: React.SFC<ListViewEventProps> = (props) => {
    const dateMoment = moment(props.day.date);
    const venueName = props.day.events[0].tessVenueName ? `${props.day.events[0].tessVenueName} in ${props.day.events[0].venueName.toUpperCase()}` : props.day.events[0].tessVenueName.toUpperCase();
    return (
        <div className="list-day">
            <h3 className="list-day-date"><b>{dateMoment.month() == 4 ? dateMoment.format("MMM DD"): dateMoment.format("MMM. DD")}</b> | <span>{dateMoment.format("dddd")}</span></h3>
            <div className="list-day-events">
            {
                props.day.events.map(evt => <ListEvent key={evt.id} event={evt} />)
            }
            </div>
        </div>
    );
}

export default listRow;


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/calendar/views/list-row.tsx